var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"svg-loader"},[_c('svg',{staticClass:"svg-container",attrs:{"height":"100","width":"100","viewBox":"0 0 100 100"}},[_c('circle',{staticClass:"loader-svg bg",attrs:{"cx":"50","cy":"50","r":"45"}}),_c('circle',{staticClass:"loader-svg animate",attrs:{"cx":"50","cy":"50","r":"45"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }